import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useMsal } from '@azure/msal-react'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { Divider } from 'primereact/divider'
import { useEventListener } from 'primereact/hooks'

export const KeyboardShortcuts: React.FC = () => {
  const [visible, setVisible] = useState(false)
  const navigate = useNavigate()
  const { instance } = useMsal()
  const { t } = useTranslation()

  const onKeyDown = (e: KeyboardEvent) => {
    // open keyboard shortcuts
    if (e.ctrlKey && (e.key === 'S' || e.key === 's')) {
      e.preventDefault()
      setVisible(!visible)
    }

    // go to tenant selection
    if (e.ctrlKey && (e.key === 'T' || e.key === 't')) {
      e.preventDefault()
      navigate('/set-tenant')
    }

    // go to history
    if (e.ctrlKey && (e.key === 'H' || e.key === 'h')) {
      e.preventDefault()
      navigate('/history')
    }

    // go to worklist
    if (e.ctrlKey && (e.key === 'W' || e.key === 'w')) {
      e.preventDefault()
      navigate('/')
    }

    // go to settings
    if (e.ctrlKey && (e.key === 'K' || e.key === 'k')) {
      e.preventDefault()
      navigate('/settings')
    }

    // logout
    if (e.ctrlKey && (e.key === 'L' || e.key === 'l')) {
      e.preventDefault()
      instance.logoutRedirect({
        postLogoutRedirectUri: '/',
      })
    }
  }

  const [bindKeyDown, unbindKeyDown] = useEventListener({
    type: 'keydown',
    listener: (e: KeyboardEvent) => {
      onKeyDown(e)
    },
  })

  useEffect(() => {
    bindKeyDown()

    return () => {
      unbindKeyDown()
    }
  }, [bindKeyDown, unbindKeyDown])

  return (
    <Dialog
      header={t('keyboardshortcuts.title')}
      visible={visible} // visible
      dismissableMask
      style={{ width: '50vw' }}
      onHide={() => setVisible(false)}
    >
      <div className="grid">
        {/* open keyboard shortcuts */}
        <div className="col-4">
          <div className="flex">
            <Button label="CTRL" outlined />
            <div className="flex align-items-center justify-content-center mx-2">
              +
            </div>
            <Button label="S" outlined />
          </div>
        </div>
        <div className="col-8 flex align-items-center">
          {t('keyboardshortcuts.openKeyboardShortscuts')}
        </div>

        <Divider className="my-2" />

        {/* go to tenant selection */}
        <div className="col-4">
          <div className="flex">
            <Button label="CTRL" outlined />
            <div className="flex align-items-center justify-content-center mx-2">
              +
            </div>
            <Button label="T" outlined />
          </div>
        </div>
        <div className="col-8 flex align-items-center">
          {t('keyboardshortcuts.goToTenants')}
        </div>

        <Divider className="my-2" />

        {/* go to history */}
        <div className="col-4">
          <div className="flex">
            <Button label="CTRL" outlined />
            <div className="flex align-items-center justify-content-center mx-2">
              +
            </div>
            <Button label="H" outlined />
          </div>
        </div>
        <div className="col-8 flex align-items-center">
          {t('keyboardshortcuts.goToHistory')}
        </div>

        <Divider className="my-2" />

        {/* go to worklist */}
        <div className="col-4">
          <div className="flex">
            <Button label="CTRL" outlined />
            <div className="flex align-items-center justify-content-center mx-2">
              +
            </div>
            <Button label="W" outlined />
          </div>
        </div>
        <div className="col-8 flex align-items-center">
          {t('keyboardshortcuts.goToWorklist')}
        </div>

        <Divider className="my-2" />

        {/* go to settings */}
        <div className="col-4">
          <div className="flex">
            <Button label="CTRL" outlined />
            <div className="flex align-items-center justify-content-center mx-2">
              +
            </div>
            <Button label="K" outlined />
          </div>
        </div>
        <div className="col-8 flex align-items-center">
          {t('keyboardshortcuts.goToSettings')}
        </div>

        <Divider className="my-2" />

        {/* logout */}
        <div className="col-4">
          <div className="flex">
            <Button label="CTRL" outlined />
            <div className="flex align-items-center justify-content-center mx-2">
              +
            </div>
            <Button label="L" outlined />
          </div>
        </div>
        <div className="col-8 flex align-items-center">
          {t('keyboardshortcuts.logout')}
        </div>
      </div>
    </Dialog>
  )
}
